class Usuario{
    constructor( p = 'padrão'){
        this.perfil = p;
    }
}
export default Usuario;